import { APP_CONFIG } from '@/core/config/app.config'

export class LocalStorageService {
  private prefix = APP_CONFIG.storage.prefix

  private getItem<T>(key: string): T | null {
    try {
      const item = localStorage.getItem(this.prefix + key)
      return item ? JSON.parse(item) : null
    } catch {
      return null
    }
  }

  private setItem<T>(key: string, value: T): void {
    try {
      localStorage.setItem(this.prefix + key, JSON.stringify(value))
    } catch {
      // Ignore storage errors
    }
  }

  private removeItem(key: string): void {
    try {
      localStorage.removeItem(this.prefix + key)
    } catch {
      // Ignore storage errors
    }
  }

  getUser(): any {
    return this.getItem(APP_CONFIG.storage.keys.user)
  }

  setUser(user: any): void {
    this.setItem(APP_CONFIG.storage.keys.user, user)
  }

  getTokens(): { accessToken: string | null; refreshToken: string | null } {
    return {
      accessToken: this.getItem(APP_CONFIG.storage.keys.accessToken),
      refreshToken: this.getItem(APP_CONFIG.storage.keys.refreshToken),
    }
  }

  setTokens(accessToken: string, refreshToken: string): void {
    this.setItem(APP_CONFIG.storage.keys.accessToken, accessToken)
    this.setItem(APP_CONFIG.storage.keys.refreshToken, refreshToken)
  }

  clearAuth(): void {
    this.removeItem(APP_CONFIG.storage.keys.user)
    this.removeItem(APP_CONFIG.storage.keys.accessToken)
    this.removeItem(APP_CONFIG.storage.keys.refreshToken)
  }

  getTheme(): string | null {
    return this.getItem(APP_CONFIG.storage.keys.theme)
  }

  setTheme(theme: string): void {
    this.setItem(APP_CONFIG.storage.keys.theme, theme)
  }

  getLanguage(): string | null {
    return this.getItem(APP_CONFIG.storage.keys.language)
  }

  setLanguage(language: string): void {
    this.setItem(APP_CONFIG.storage.keys.language, language)
  }
}
